import { useTheme } from '@mui/material'
import { Button, InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'

type CreateWalletConfirmModalProps = {
  open: boolean
  loading: boolean
  onClose: () => void
  onCreate: () => Promise<void>
}
export const CreateCryptoWalletConfirmModal = ({
  open,
  loading,
  onClose,
  onCreate,
}: CreateWalletConfirmModalProps) => {
  const { zIndex } = useTheme()
  const { t } = useTranslation('wallet')

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('confirm')}
      content={t('confirmModalContent')}
      buttons={[
        <Button
          size="large"
          sx={{ minWidth: 212 }}
          onClick={onCreate}
          loading={loading}
        >
          {t('create')}
        </Button>,
      ]}
      cancelText={t('close')}
      sx={{ zIndex: zIndex.modal + 999 }}
    />
  )
}
